/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';
import template from './report-template-list-page.component.html';

import {AdminListColumn, AdminResourceListPageBase} from '../common/controller/admin-resource-list-page-base';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';

@Component({
  standalone: false,
  selector: 'adn-report-template-list-page',
  template
})
export class ReportTemplateListPageComponent extends AdminResourceListPageBase {
  readonly itemStateName = 'app.rep.report-templates.report-template';

  columns: AdminListColumn[] = [
    {param: 'name'},
    {label: 'reportType', param: 'reportType'},
    {label: 'team', param: '', sortable: false}
  ];

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any
  ) {
    super(LocalNetworkProfile);
  }
}
